import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
/**
 * DOM node of the slot where a `SidePanel` portals itself so it becomes a flex
 * sibling of the main content — pushing and resizing it rather than overlapping.
 * The slot sits on the left (matching the Charts settings panel). `null` until
 * the layout has mounted (or when there is no `SidePanelLayout` ancestor,
 * letting consumers fall back to an overlay).
 */
const SidePanelSlotContext = createContext(null);
export const useSidePanelSlot = () => useContext(SidePanelSlotContext);
/**
 * Horizontal layout shell that mirrors the Charts settings-panel arrangement:
 * a left slot receives a portalled `SidePanel`, and `children` (the main page
 * content) grow to fill the remaining width. When the panel is open it pushes
 * the content and the content resizes responsively; when closed the slot
 * collapses to zero width. Content must set `min-w-0` so it can shrink.
 */
export const SidePanelLayout = ({ children, dataTestId }) => {
    const [slot, setSlot] = useState(null);
    return (_jsxs("div", { className: 'flex h-full overflow-hidden', "data-testid": dataTestId, children: [_jsx("aside", { ref: setSlot, className: 'flex h-full' }), _jsx(SidePanelSlotContext.Provider, { value: slot, children: children })] }));
};
